<template>
    <div>
        <b-container fluid class="ds-top-body">
            <h4 class="pt-5 pb-4 fw-600"> 답변 확인할 기업 선택 </h4>
            <b-row class="mb-5 bgray-200 py-3">
                <b-col cols="0" md="2" lg="3"></b-col>
                <b-col cols="12" md="8" lg="6">
                    <b-form-input v-model="search_keyword" debounce="300" placeholder="검색할 기업명 입력"></b-form-input>
                </b-col>
                <b-col cols="0" md="2" lg="3"></b-col>
            </b-row>

            <h5 class="pt-4 pb-2 border-bottom border-color-gray-300">
                참여 기업 ({{ filtered_companies.length }} 개사)
                <span v-if="canceled_count > 0" class="f-85 gray-600">(취소 {{ canceled_count }}개사 제외)</span>
            </h5>
            <b-button v-for="(item, index) in filtered_companies"
                      :key="`company-${item.company_id}-${index}`"
                      variant="dark-border"
                      class="mr-2 mb-3 py-1 px-2"
                      @click="selectCompany(item)"
            >
                {{ item.company_name }}
            </b-button>
            <p v-if="filtered_companies.length === 0 && !sub_layout_loading" class="gray-600 py-3">
                {{ search_keyword ? '검색 결과가 없습니다.' : '참여 기업이 없습니다.' }}
            </p>
            <hr class="border-0 bottom-space">
        </b-container>
    </div>
</template>

<script>
import {mapState} from 'vuex';


export default {
    name: 'Answers',
    computed: {
        ...mapState(['admin_mode', 'is_admin']),
        ...mapState('score', ['temp_target_companies']),
        ...mapState('admin', ['sub_layout_loading']),
        // 검색어는 ?q= 에 둬서 기업 답변을 보고 돌아와도(다른 기업 선택·뒤로가기) 유지된다
        search_keyword: {
            get() {
                return typeof this.$route.query.q === 'string' ? this.$route.query.q : '';
            },
            set(value) {
                const q = value || undefined;
                if (q === this.$route.query.q) return;
                this.$router.replace({query: {...this.$route.query, q}}).catch(() => {});
            }
        },
        canceled_count() {
            return this.temp_target_companies.filter(x => x.status_code === 'canceled').length;
        },
        filtered_companies() {
            const keyword = this.search_keyword.trim().toLowerCase();
            return this.temp_target_companies.filter(x => x.status_code !== 'canceled'
                && (!keyword || (x.company_name || '').toLowerCase().includes(keyword)));
        },
    },
    methods: {
        async selectCompany(target_company) {
            const {template_code, project_code, campaign_id, company_id, company_name} = target_company;
            const {client, campaign_name, q} = this.$route.query;
            
            if(this.admin_mode === 'project'){
                this.$router.push({
                    name: 'CompanyAnswers',
                    params: {company_id},
                    query: {client, cpn: company_id, cmp: campaign_id, pc: project_code, cpnm: company_name, template_code, admin_mode: this.admin_mode, q}
                });
            }
            if(this.admin_mode === 'camp'){
                this.$router.push({
                    name: 'CompanyAnswers',
                    params: {company_id},
                    query: {campaign_name, cpn: company_id, cmp: campaign_id, pc: project_code, cpnm: company_name, template_code, admin_mode: this.admin_mode, q}
                });
            }

            
        },
    }
};
</script>
